import React from "react";
import { MeshStandardMaterial } from "three";
import RectangularTube from "./rectangularTubes";

const Columns = ({ columns, selectedFloor }) => 
{
  const selectedMaterial = new MeshStandardMaterial({ color: "#20dcd9", transparent: true, opacity: 0.7 });
  const hideMaterial = new MeshStandardMaterial({ color: "#e2eeee", transparent: true, opacity: 0.1 });

  return (
    <>
      {columns.map((column) => {
        const { geometry, id, position } = column;
        const { floor, x, z, base, top } = position;
        const { b, height, h, e } = geometry;

        const material = floor === selectedFloor ? selectedMaterial : hideMaterial;

        return (
          <mesh
            name={`Column_${id}_Floor${floor}`} // ← Renombrado, no comienza con "mesh"
            key={`column-${id}-floor-${base}-${Math.random(0, 1000)}`}
            position={[x, (base + top) / 2, z]}
            material={material}
            //onClick={() => floor === selectedFloor ? console.log(column) : null}
          >
            <RectangularTube
              b={b}
              h={h}
              height={height}
              e={e}
              material={material}
            />
          </mesh>
        );
      })}
    </>
  );
};

export default Columns;